import type {PromptSlotKind} from '../../utils/promptPlaceholders';

const MOCK: Record<PromptSlotKind, string[]> = {
    category: [
        'IT & Software',
        'Office supplies',
        'Professional services',
        'Logistics',
        'Manufacturing materials',
    ],
    supplier: ['Acme Corp', 'Globex', 'Initech', 'Umbrella Logistics'],
    material: ['Steel grade A', 'Polymer resin', 'Electronic components'],
    plant: ['Plant A — North', 'Plant B — South', 'HQ warehouse'],
    cost_center: ['CC-100 Operations', 'CC-200 R&D', 'CC-300 G&A'],
    generic: ['Option A', 'Option B', 'Option C'],
};

export function getMenuOptionsForSlotKind(kind: PromptSlotKind): string[] {
    return MOCK[kind] ?? MOCK.generic;
}

export function menuTitleForSlotKind(kind: PromptSlotKind, label: string): string {
    switch (kind) {
        case 'category':
            return 'Choose category';
        case 'supplier':
            return 'Choose supplier';
        case 'material':
            return 'Choose material';
        case 'plant':
            return 'Choose plant';
        case 'cost_center':
            return 'Choose cost center';
        default:
            return `Choose ${label}`;
    }
}
